


import UMUM from "../../library/umum.js";
export default {
    data() {
        return {

            list_data: [],
            editorToolbar: [
                ['bold', 'italic', 'underline'],
                ['link', 'quote', 'unordered', 'ordered'],
                ['left', 'center', 'right', 'justify'],
                ['image'],
                ['viewsource']
            ],
            form: {
                isi: '',
                judul: '',
                sumber: '',
                // deskripsi: '',
                file_name: null
            },
            fileBaru: null,

            UMUM: UMUM,
            btn_add: false,
            btn_edit: false,

            mdl_add: false,
            mdl_edit: false,
            mdl_delete: false,
            mdl_lihat: false,
            mdl_image: false,
            selectedImage: null,

            alert: false,


            cari_value: "",
            page_first: 1,
            page_last: 1,
            page_limit: 9,
            total: 0,


            // tipe: null,


            file_path: this.$store.state.url.URL_APP + "uploads/",


        }


    },


    methods: {

        openEdit(data) {
            this.form = { ...data, isi: data.isi || '' }
            this.mdl_edit = true
        },
        openDelete(data) {
            this.form = { id: data.id }
            this.mdl_delete = true
        },

        openLihat(data) {
            this.form = { ...data, isi: data.isi || '' }
            this.mdl_lihat = true
        },

        openImage(src) {
            this.selectedImage = src
            this.mdl_image = true
        },




        formatRupiah(value) {
            if (value == null) return "-";
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        },


        resetForm() {
            this.form = {
                judul: '',
                sumber: '',
                // deskripsi: '',
                isi: '',
                file_name: null
            }
        },

        // ambil data utama
        getView() {
            this.$store.commit("shoWLoading");

            fetch(this.$store.state.url.BERITA + "getview", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    data_ke: this.page_first,
                    cari_value: this.cari_value,
                    page_limit: this.page_limit
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    this.list_data = res_data.data;
                    this.total = res_data.total;
                    this.page_last = Math.ceil(this.total / this.page_limit);
                    this.$store.commit("hideLoading");
                })
                .catch(err => {
                    console.error("❌ Error getView:", err);
                    this.$store.commit("hideLoading");
                });
        },

        addData() {
            this.btn_add = true;
            const formData = new FormData();

            formData.append("judul", this.form.judul);
            formData.append("sumber", this.form.sumber);
            // formData.append("deskripsi", this.form.deskripsi);
            formData.append("isi", this.form.isi);
            if (this.form.file_name) {
                formData.append("file_name", this.form.file_name); // harus sama dengan upload.single("file_name")
            }

            fetch(this.$store.state.url.BERITA + "addData", {
                method: "POST",
                headers: {
                    authorization: "kikensbatara " + localStorage.token
                },
                body: formData
            })
                .then(res => res.json())
                .then(res_data => {
                    this.btn_add = false;
                    if (res_data.success) {
                        this.Notify("Sukses Menambah Data", "primary", "check_circle_outline");
                        this.getView();
                        this.mdl_add = false;
                        this.resetForm();
                    } else {
                        this.Notify(res_data.message || "Gagal Menambah Data", "negative", "error_outline");
                    }
                })
                .catch(err => {
                    this.btn_add = false;
                    console.error("❌ Error:", err);
                    this.Notify("Terjadi kesalahan server", "negative", "error_outline");
                });
        },

        async updateData() {
            try {
                const formData = new FormData()
                formData.append("id", this.form.id)
                formData.append("judul", this.form.judul)
                formData.append("sumber", this.form.sumber)
                // formData.append("deskripsi", this.form.deskripsi)
                formData.append("isi", this.form.isi)

                // kalau user upload file baru → kirim file
                if (this.fileBaru) {
                    formData.append("file", this.fileBaru)
                } else {
                    // kalau tidak upload file baru → tetap kirim nama file lama
                    formData.append("file_name", this.form.file_name)
                }

                const res = await fetch(this.$store.state.url.BERITA + "updateData", {
                    method: "POST",
                    headers: {
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: formData
                })

                const result = await res.json()
                if (result.success) {
                    this.$q.notify({ type: "positive", message: result.message })
                    this.mdl_edit = false
                    this.getView()
                } else {
                    this.$q.notify({ type: "negative", message: result.message })
                }
            } catch (err) {
                console.error("❌ Error updateData:", err)
                this.$q.notify({ type: "negative", message: "Gagal update data" })
            }
        },

        removeData() {
            fetch(this.$store.state.url.BERITA + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({ id: this.form.id })
            })
                .then(res => res.json())
                .then(res_data => {
                    if (res_data.success) {
                        this.Notify(res_data.message || '✅ Sukses Menghapus Data', 'negative', 'check_circle_outline')
                        this.getView()
                    } else {
                        this.Notify(res_data.message || '⚠️ Data tidak ditemukan', 'warning', 'error')
                    }
                })
                .catch(err => {
                    this.Notify('❌ Error: ' + err.message, 'warning', 'error')
                })
        },


        simulateProgress(number) {
            // we set loading state
            this[`simpan${number}`] = true
            // simulate a delay
            setTimeout(() => {
                // we're done, we reset loading state
                this[`simpan${number}`] = false
            }, 3000)
        },

        Notify: function (message, positive, icon) {
            this.$q.notify({
                message: message,
                color: positive,
                icon: icon,
                position: 'top',
                timeout: 500,
            })
        },


        btn_prev() {
            if (this.page_first > 1) this.page_first--;
            this.getView();
        },

        btn_next() {
            if (this.page_first < this.page_last) this.page_first++;
            this.getView();
        },

        cari_data() {
            this.page_first = 1;
            this.getView();
        },

        indexing(index) {
            return ((this.page_first - 1) * this.page_limit) + index;
        },


    },
    mounted() {

        const get_profile = JSON.parse(localStorage.profile);
        // this.tipe = Number(get_profile.profile.stokdarah_konut); 

        this.getView();

    }
}
